import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1.5),
};

export const headerItem: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  background: (p) => p.palette.common.white,
  gap: (p) => p.spacing(1),
};
